export default __webpack_public_path__ + "static/media/37.6c0c7de7.svg";